import React from 'react';

const ListExpenseCategories = () => {
  return <h2>List Expense Categories</h2>;
};

export default ListExpenseCategories;
